import { inject, Injectable, signal } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { SuggestionList } from '../interfaces';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class Suggestion {
  private _http = inject(HttpClient);
  
  private _suggestionList = signal<SuggestionList | undefined>(undefined);
  public suggestionList = this._suggestionList.asReadonly();
  
  private _isLoadingSuggestionList = signal<boolean>(false);
  public isLoadingSuggestionList = this._isLoadingSuggestionList.asReadonly();
  
  public setIsLoadingSuggestionList(value: boolean): void {
    this._isLoadingSuggestionList.set(value);
  }
  
  getEventDetailsServiceSignal(token: string): void {
    if (!token) return; 
    
    this._isLoadingSuggestionList.set(true);

    this.getSuggestionList(token)
      .subscribe((response: SuggestionList) => {
        console.log('Suggestion List fetched:', response);
        this._suggestionList.set(response);
        this._isLoadingSuggestionList.set(false);
      });
  }
  
  getSuggestionList(token: string): Observable<SuggestionList> {
    const url = environment.apiUrlBase + '/api/get-category-related-items'
    console.log('url', url);
    return this._http.post<SuggestionList>(url, { token: token }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching suggestion list:', error);
        return throwError(() => error);
      }),
    );
  }
}
